export default "__VITE_ASSET__b48fd696__"